import CitySEOHead from "@/components/feature/CitySEOHead";
import LittleRockHeroSection from "./components/HeroSection";
import LittleRockStickyNav from "./components/StickyNav";
import LittleRockProcessingTimeSection from "./components/ProcessingTimeSection";
import LittleRockServicesSection from "./components/ServicesSection";
import LittleRockLocalAreaSection from "./components/LocalAreaSection";
import LittleRockTravelTimingSection from "./components/TravelTimingSection";
import LittleRockDestinationsSection from "./components/DestinationsSection";
import LittleRockTestimonialsSection from "./components/TestimonialsSection";
import LittleRockAcceptanceFacilitiesSection from "./components/AcceptanceFacilitiesSection";
import LittleRockComparisonSection from "./components/ComparisonSection";
import LittleRockMistakesSection from "./components/MistakesSection";
import LittleRockHowItWorksSection from "./components/HowItWorksSection";
import LittleRockFAQSection, { faqs } from "./components/FAQSection";
import LittleRockHelpfulResourcesSection from "./components/HelpfulResourcesSection";
import LittleRockFinalCTA from "./components/FinalCTA";
import SEOCrossLinks from "@/components/feature/SEOCrossLinks";

const littleRockServices = [
  { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
  { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
  { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
  { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
  { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
  { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
];

export default function LittleRockPage() {
  return (
    <div className="font-sans">
      <CitySEOHead
        city="Little Rock"
        state="Arkansas"
        stateAbbr="AR"
        route="/cities/little-rock"
        title="Emergency Passport Little Rock, AR — Expedited & Fast Passport Service | Fast Passport Center"
        description="Emergency and expedited passport services in Little Rock, AR — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Arkansas state officials, UALR students, UAMS medical professionals, and families."
        geoPlacename="Little Rock, Arkansas"
        geoPosition="34.7465;-92.2896"
        faqs={faqs}
        servicesSchema={littleRockServices}
        statePageName="Arkansas"
        statePageRoute="/states/arkansas"
      />
      <LittleRockHeroSection />
      <LittleRockStickyNav />
      <LittleRockProcessingTimeSection />
      <LittleRockServicesSection />
      <LittleRockLocalAreaSection />
      <LittleRockTravelTimingSection />
      <LittleRockDestinationsSection />
      <LittleRockTestimonialsSection />
      <LittleRockAcceptanceFacilitiesSection />
      <LittleRockComparisonSection />
      <LittleRockMistakesSection />
      <LittleRockHowItWorksSection />
      <LittleRockFAQSection />
      <LittleRockHelpfulResourcesSection />
      <SEOCrossLinks currentRoute="/cities/little-rock" state="AR" />
      <LittleRockFinalCTA />
    </div>
  );
}